module.exports = __webpack_public_path__ + "static/media/dogan.df3bf97f.jpg";